/* unplugin-vue-components disabled */import { render } from "./SpeachGenerationLoader.vue?vue&type=template&id=dc1dfe30&scoped=true&ts=true"
import script from "./SpeachGenerationLoader.vue?vue&type=script&lang=ts"
export * from "./SpeachGenerationLoader.vue?vue&type=script&lang=ts"

import "./SpeachGenerationLoader.vue?vue&type=style&index=0&id=dc1dfe30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1dfe30"]])

export default __exports__